module.exports = __webpack_public_path__ + "static/media/15@960w.6544e894.jpg";